export class NewFilter {
    categoryName
    filterType = 'new'
    constructor(categoryName) {
        this.categoryName = categoryName
    }

    apply(products) {
        return products.filter(product => {
            return (product.Estado.toLowerCase() === 'nuevo')
        })
    }
}